import React from 'react';
import { connect } from 'react-redux';
import './styles.scss';

import {
  setScrewPaddingS,
  setScrewPaddingD,
  setScrewShiftC1,
  setScrewShiftC,
  setScrewNCount,
  setScrewMaxLength,
  toggleScrewMaxLength,
} from '@reducers/options/screw/actions';

import { setGradeSteelBar } from '@reducers/selectors/dimension/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

import Input from '@components/Input';
import { APP_TEXTS } from '../../../texts/texts';
import { standardList } from './../../../app.values';

const ReinforcementParameters = props => (
  <div className="calculation base-plate">
      <section className="list-type">
        <div className="d-flex justify-content-between align-items-center pl-3 pr-1 ReinforcementParameters__select-holder">
          <span>{APP_TEXTS.GRADE_STEEL_BAR.Content}</span>

          <select
            onChange={e => props.setGradeSteelBar(e.target.value)}
            className="form-control ReinforcementParameters__select"
            name="steelBar"
            value={props.gradeSteelBar}
          >
            <option value="Fe E500">
              {Number(props.designStd) === standardList["AS3600"] || Number(props.designStd) === standardList["ANZ"] ||
                Number(props.designStd) === standardList['AS5216'] ? 
                "Gr 500" : "Fe E500"}
            </option>
            {Number(props.designStd) !== standardList["AS3600"] && Number(props.designStd) !== standardList['AS5216'] && (
              <option value="Fe E400">
                {Number(props.designStd) === standardList["ANZ"] ? 
                  "Gr 400" : "Fe E400"}
              </option>
            )}
          </select>
        </div>

        <div className="form-check d-flex justify-content-between mt-2 pr-1 ReinforcementParameters__length">
          <div className="custom-control custom-checkbox">
            <input
              className="custom-control-input"
              id="max-length"
              type="checkbox"
              checked={props.maxLength.active}
              onChange={props.toggleMaxLength}
            />
            <label className="custom-control-label" htmlFor="max-length">{APP_TEXTS.MAX_INSTALLATION_LENGTH.Content}</label>
          </div>

          <Input
            id="max-length-value"
            postfix={unitLabel(props.distanceUnit)}
            type="number"
            minValue={0}
            value={unitTransform(+props.maxLength.value || 0).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
            disabled={!props.maxLength.active}
            onUpdate={value => {
              props.setMaxLength(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
            }}
          />
        </div>

        <div className="form-check d-flex justify-content-between mt-0 pr-1 ReinforcementParameters__layers">
          <span>{APP_TEXTS.REINFORCEMENT_PARAMETERS_LAYERS.Content}&nbsp;=</span>

          <Input
            id="layers"
            postfix="&nbsp;&nbsp;"
            type="number"
            minValue={0}
            value={props.screw.count.n}
            onUpdate={props.setN}
          />
        </div>

        <div className="form-check justify-content-between align-items-center pr-1 ReinforcementParameters__numbers">
          <Input
            className="form-check-label mt-2"
            id="s"
            prefix="S ="
            postfix={unitLabel(props.distanceUnit)}
            type="number"
            minValue={0}
            value={unitTransform(+props.screw.padding.s || 0).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
            onUpdate={value => {
              props.setPaddingS(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
            }}
          />

          <Input
            className="form-check-label mt-2"
            id="c1"
            prefix="C1 ="
            postfix={unitLabel(props.distanceUnit)}
            type="number"
            minValue={0}
            value={props.screw.shift ? unitTransform(+props.screw.shift.c1 || 0).from(defaultUnits.DISTANCE).to(props.distanceUnit) : 0}
            onUpdate={value => {
              props.setShiftC1(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
            }}
          />
        </div>

        <div className="form-check justify-content-between align-items-center pr-1 ReinforcementParameters__numbers">
          <Input
            className="form-check-label mt-2"
            id="d"
            prefix="D ="
            postfix={unitLabel(props.distanceUnit)}
            type="number"
            minValue={0}
            value={unitTransform(+props.screw.padding.d || 0).from(defaultUnits.DISTANCE).to(props.distanceUnit)}
            onUpdate={value => {
              props.setPaddingD(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
            }}
          />

          <Input
            className="form-check-label mt-2"
            id="c"
            prefix="C ="
            postfix={unitLabel(props.distanceUnit)}
            type="number"
            minValue={0}
            value={props.screw.shift ? unitTransform(+props.screw.shift.c || 0).from(defaultUnits.DISTANCE).to(props.distanceUnit) : 0}
            onUpdate={value => {
              props.setShiftC(unitTransform(+value, false).from(props.distanceUnit).to(defaultUnits.DISTANCE));
            }}
          />
        </div>
      </section>
    </div>
);

const mapState = state => ({
  screw: state.options.screw,
  maxLength: state.options.screw.maxLength || { active: false, value: 0 },
  gradeSteelBar: state.selectors.dimension[state.main.appType].reinforcementParameters.gradeSteelBar,

  distanceUnit: state.main.units.distance,
  designStd: state.main.localization.designStandard
});

const mapDispatch = dispatch => ({
  setShiftC: value => dispatch(setScrewShiftC(parseFloat(value))),
  setShiftC1: value => dispatch(setScrewShiftC1(parseFloat(value))),
  setPaddingD: value => dispatch(setScrewPaddingD(parseFloat(value))),
  setPaddingS: value => dispatch(setScrewPaddingS(parseFloat(value))),
  setN: value => dispatch(setScrewNCount(parseFloat(value))),
  setMaxLength: value => dispatch(setScrewMaxLength(parseFloat(value))),
  toggleMaxLength: e => dispatch(toggleScrewMaxLength(e.target.checked)),

  setGradeSteelBar: value => dispatch(setGradeSteelBar(value))
});

export default connect(mapState, mapDispatch)(ReinforcementParameters);



// WEBPACK FOOTER //
// ./src/views/Dimension/Rebar/ReinforcementParameters.js